import { RESET_RESULT, SEND_RESULT as SOCKET_SEND_RESULT, VOTED as SOCKET_VOTED, VOTED_AMAGGIORANZA as SOCKET_VOTED_AMAGGIORANZA, CHOICED as SOCKET_CHOICED} from '../../events/DashboardToServer'
import { RESET_RESULT as SOCKET_RESET_RESULT} from '../../events/DashboardToServer'
import { NUM_PLAYERS_CHANGED } from '../actions'


export const RESULT_SENT = 'ANSWER_SENT'
export const RESULT_RESETTED = 'RESULT_RESETTED'
export const SEND_RESULT = 'SEND_RESULT'
export const VOTED = 'VOTED'
export const VOTED_AMAGGIORANZA = 'VOTED_AMAGGIORANZA'
export const VOTE_RECEIVED = 'VOTE_RECEIVED'
export const VOTE_AMAGGIORANZA_RECEIVED = 'VOTE_AMAGGIORANZA_RECEIVED'
export const CHOICED = 'CHOICED'
export const CHOICE_RECEIVED = 'CHOICE_RECEIVED'



export const result = (state = [], action) => {
    switch (action.type) {

        case NUM_PLAYERS_CHANGED:
            var ss = {
                ...state,
            }
            if (ss.result==undefined) ss.result = 0; 
            return ss   


        case RESULT_SENT:
            var ss = {
                ...state,
            }
            if (ss.result!=0) ss.result=Math.min(action.result, ss.result);
            else ss.result = action.result
            if (ss.result<0) ss.result = 1;
            if (ss.result>20) ss.result = 20;

            return ss   

        case VOTE_RECEIVED:
            var ss = {
                ...state,
            }
            ss.result =  ss.result + action.vote
            if (ss.result >= 21){
                ss.result =  ss.result-20;
            }
            if (ss.result == 0) ss.result = 1;
            return ss   

        case VOTE_AMAGGIORANZA_RECEIVED:
            var ss = {
                ...state,
            }
            if (action.vote == 0){
                ss.result = ss.result -1;
            }else ss.result =  ss.result + 1

            return ss   

        case CHOICE_RECEIVED:
            var ss = {
                ...state,
            }
            ss.numberOfVotes=ss.numberOfVotes?ss.numberOfVotes:0;
            ss.result = ss.result?ss.result:0
            ss.result = Math.round(((ss.result*ss.numberOfVotes) + action.choice)/(ss.numberOfVotes+1))
            ss.numberOfVotes++
            return ss   
    

        case RESULT_RESETTED:
            var ss = {
                ...state,
            }
            ss.result = 0
            ss.numberOfVotes = 0;
            return ss 
                

        case SEND_RESULT:
            var ss = {
                ...state,
            }
            ss.result = action.result
            return ss 

                
        default:

            var ss = {
                ...state,
            }
            return ss 
    }
}

export const resultSent = (result) => {
    return { type: RESULT_SENT, result: result}
}

export const sendResult = (socket, result) => {
    socket.emit(SOCKET_SEND_RESULT, result)
    return { type: SEND_RESULT, result: result}
}

export const resultResetted = () => {
    return { type: RESULT_RESETTED}
}

export const resetResult = (socket) => {
    socket.emit(SOCKET_RESET_RESULT)
    return { type: RESET_RESULT}
}

export const voted = (socket,vote) => {
    socket.emit(SOCKET_VOTED, vote)
    return { type: VOTED, vote: vote}
}

export const votedAMaggioranza = (socket,vote) => {
    socket.emit(SOCKET_VOTED_AMAGGIORANZA, vote)
    return { type: VOTED_AMAGGIORANZA, vote: vote}
}


export const choiced = (socket,choice) => {
    socket.emit(SOCKET_CHOICED, choice)
    return { type: CHOICED, choice: choice}
}

export const voteReceived = (vote) => {
    return { type: VOTE_RECEIVED, vote: vote}
}

export const voteAMaggioranzaReceived = (vote) => {
    return { type: VOTE_AMAGGIORANZA_RECEIVED, vote: vote}
}

export const choiceReceived = (choice) => {
    return { type: CHOICE_RECEIVED, choice: choice}
}



// WEBPACK FOOTER //
// ./src/reducers/result/index.js